import { scrollReduxGenerator } from '@/util/reduxGenerator/index'
import { url, api } from '@/config/api'

export const {
  reducer,
  
  list_success,
  list_error,
  list_reset,
  list_loading,
  list_loaded,
  
  getRandList,
} = scrollReduxGenerator({
  type: 'rand',
  listApi: url + api.getRand
})
